// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"318":"dc2f890d","467":"03cae577"}[chunkId] + ".chunk.js";
};